/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Empty_State_Bookings_Revenue_DescriptionInputs */

const en_admin_dashboard_empty_state_bookings_revenue_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Bookings_Revenue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Increase revenue with your resources`)
};

const de_admin_dashboard_empty_state_bookings_revenue_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Bookings_Revenue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Umsatz steigern mit Meetingräumen und anderen Ressourcen`)
};

const es_admin_dashboard_empty_state_bookings_revenue_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Bookings_Revenue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumenta los ingresos con tus recursos`)
};

const fr_admin_dashboard_empty_state_bookings_revenue_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Bookings_Revenue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Augmentez vos revenus avec vos ressources`)
};

const it_admin_dashboard_empty_state_bookings_revenue_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Bookings_Revenue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumenta le entrate con le tue risorse`)
};

const pt_br2_admin_dashboard_empty_state_bookings_revenue_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Bookings_Revenue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aumente a receita com seus recursos`)
};

const pl_admin_dashboard_empty_state_bookings_revenue_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Bookings_Revenue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zwiększ przychody dzięki swoim zasobom`)
};

const hu_admin_dashboard_empty_state_bookings_revenue_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Bookings_Revenue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Növelje bevételét erőforrásaival`)
};

const ro_admin_dashboard_empty_state_bookings_revenue_description = /** @type {(inputs: Admin_Dashboard_Empty_State_Bookings_Revenue_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cresteti veniturile cu resursele dumneavoastra`)
};

/**
* | output |
* | --- |
* | "Increase revenue with your resources" |
*
* @param {Admin_Dashboard_Empty_State_Bookings_Revenue_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_empty_state_bookings_revenue_description = /** @type {((inputs?: Admin_Dashboard_Empty_State_Bookings_Revenue_DescriptionInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Empty_State_Bookings_Revenue_DescriptionInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_empty_state_bookings_revenue_description(inputs)
	if (locale === "de") return de_admin_dashboard_empty_state_bookings_revenue_description(inputs)
	if (locale === "es") return es_admin_dashboard_empty_state_bookings_revenue_description(inputs)
	if (locale === "fr") return fr_admin_dashboard_empty_state_bookings_revenue_description(inputs)
	if (locale === "it") return it_admin_dashboard_empty_state_bookings_revenue_description(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_empty_state_bookings_revenue_description(inputs)
	if (locale === "pl") return pl_admin_dashboard_empty_state_bookings_revenue_description(inputs)
	if (locale === "hu") return hu_admin_dashboard_empty_state_bookings_revenue_description(inputs)
	return ro_admin_dashboard_empty_state_bookings_revenue_description(inputs)
});
export { admin_dashboard_empty_state_bookings_revenue_description as "admin.dashboard.empty_state.bookings_revenue.description" }